(function ($) {
	/**
	 * Filter menu script
	 */
	class P_FilterMenu {
	    constructor() {
	        this.initState();
	    }
	
	    initState() {
	        this.filterSelect = $('.filter-item-select');
	
	        if (this.filterSelect.length) {
	            this.initEvents();
	        }
	    }
	
	    initEvents() {
	        for (let i = 0; i < this.filterSelect.length; i++) {
	            this.activator = this.filterSelect.eq(i).find('.filter-item-activator');
	
	            this.activator.on('click', function (e) {
	                e.preventDefault();
	                e.stopPropagation();
	
	                filterSelect.forEach(item => {
	                    if (item !== filterSelect[i]) {
	                        item.removeClass('active');
	                    }
	                });
	
	                setTimeout(() => {
	                    if (e.target.tagName !== 'BUTTON') {
	                        filterSelect[i].toggleClass('active');
	                    }
	                }, 100);
	            });
	        }
	
	        document.on('click', function (e) {
	            filterSelect.forEach(item => {
	                if (!item.contains(e.target)) {
	                    item.removeClass('active');
	                }
	            });
	        });
	    }
	}
	
	
	/**
	 * Filter menu script
	 */
	class P_Menu {
		constructor() {
			this.initState();
		}
	
		initState() {
			this.header = $('.header');
	
			if (this.header.length) {
				this.initEvents();
			}
		}
	
		initEvents() {
			this.headerMenuButton = this.header.find('.toggle-menu');
			this.headerMenu = this.header.find('.header-menu-left');
			this.headerSubMenuButton = this.headerMenu.find('.menu-item-has-children');
			this.headerSubMenuButton.append('<span class="arrow"></span>');
			this.mobileViewport = window.matchMedia('(max-width: 1024px)');
	
			if (this.mobileViewport.matches) {
				this.mobileMenu();
			}
	
			this.mobileViewport.addListener(mq => {
				if (mq.matches) {
					this.mobileMenu();
				}
			});
		}
	
		mobileMenu() {
			this.headerMenuButton.on('click', (e) => {
				e.preventDefault();
				this.header.toggleClass('active');
				this.headerMenuButton.toggleClass('active');
				$('body').toggleClass('no-scroll');
			})
	
			if (this.headerSubMenuButton) {
				for (let i = 0; i < this.headerSubMenuButton.length; i++) {
					this.headerSubMenuButton.eq(i).children('a').on('click', (e) => {
						e.preventDefault();
	
						this.headerSubMenuButton.each(function (i, item) {
							$(item).toggleClass('hidden');
							setTimeout(() => {
								$(item).toggleClass('absolute');
							}, 200);
						});
	
						this.headerSubMenuButton.eq(i).toggleClass('active');
						this.header.find('.header-menu-right').toggleClass('hidden');
	
						setTimeout(() => {
							this.header.find('.header-menu-right').toggleClass('absolute');
							this.headerSubMenuButton.eq(i).toggleClass('absolute');
						}, 200);
	
						setTimeout(() => {
							this.headerSubMenuButton.eq(i).removeClass('absolute');
							this.headerSubMenuButton.eq(i).removeClass('hidden');
						}, 10);
					})
				}
			}
		}
	}
	
	/**
	 * Social sharing buttons script
	 */
	 class P_SocialSharing {
	  constructor() {
	    if(!$('.block-share').length) {
	      return;
	    }
	    this.initPopups();
	  }
	  initPopups() {
	    $('.post-sharing-link').each(function(i, link) {
	      $(link).on('click', function(e) {
	        e.preventDefault();
	        window.open($(link).attr('href'), 'Share this post', 'width=500,height=400,resizable=yes').focus();
	      });
	    });
	  }
	}
	
	/**
	 * Survey popup script
	 */
	class P_SurveyPopup {
		constructor() {
			this.initState();
		}
	
		initState() {
			this.openPopupBtn = $('.open-survey-popup');
			this.surveyPopup = $('.survey-popup');
			this.openForm = this.surveyPopup.find('.open-form');
			this.questionsList = this.surveyPopup.find('.ss-survey');
	    this.questions = this.surveyPopup.find('.question-box');
	    this.nextBtn = this.surveyPopup.find('.next-question');
	    this.prevBtn = this.surveyPopup.find('.prev-question');
			this.submitBtn = $('input[type="submit"');
			this.currentItem = 0;
	    this.animationInProgress = false;
	
			if (this.openPopupBtn.length) {
				this.initEvents();
			}
		}
	
		initEvents() {
			this.openForm.on('click', e => {
				e.preventDefault();
				$('.popup-form-intro').addClass('is-hidden');
				this.questionsList.addClass('is-visible');
				this.nextBtn.removeClass('is-hidden');
				this.prevBtn.removeClass('is-hidden');
				this.prevBtn.addClass('back-to-intro');
			});
	
	    this.nextBtn.on('click', e => {
	      e.preventDefault();
	
	      if (this.animationInProgress) {
	        return;
	      }
	      this.animationInProgress = true;
	
				console.log('next curIt:', this.currentItem)
				console.log('ilosc', this.questions.length);
				
				this.currentItem++;
	
	      if (this.currentItem >= this.questions.length - 1) {
	        this.nextBtn.addClass('is-hidden');
					this.submitBtn.addClass('is-visible');
	      }  
	
	      this.questions.removeClass('is-active');
	      this.questions.eq(this.currentItem).addClass('is-active');
	      this.prevBtn.removeClass('is-hidden');
				this.prevBtn.removeClass('back-to-intro');
	
	      setTimeout(() => {
	        this.animationInProgress = false;
	      }, 550);
	    });
	
	    this.prevBtn.on('click', e => {
				if(this.prevBtn.hasClass('back-to-intro')) {
					e.preventDefault();
	        $('.popup-form-intro').removeClass('is-hidden');
					this.questionsList.removeClass('is-visible');
					this.nextBtn.addClass('is-hidden');
					this.prevBtn.addClass('is-hidden');
					this.prevBtn.removeClass('back-to-intro');
				} else {
					e.preventDefault();
	
					if (this.animationInProgress) {
						return;
					}
	
					this.animationInProgress = true;
	
					console.log('prev curIt:', this.currentItem)
					console.log('ilosc', this.questions.length);
	
					this.currentItem--;
	
					if (this.currentItem === 0) {
						this.prevBtn.addClass('is-hidden');
						this.prevBtn.addClass('back-to-intro');
					}
	
					this.questions.removeClass('is-active');
					this.questions.eq(this.currentItem).addClass('is-active');
					this.nextBtn.removeClass('is-hidden');
	
					setTimeout(() => {
						this.animationInProgress = false;
					}, 550);
				}
	    });
	  }
	}
	
	
	/*
	 * Tabs script
	 */
	class P_Tabs {
	    constructor(wrapper) {
	        this.wrapper = $(wrapper);
	        this.initState();
	        this.initEvents();
	    }
	
	    initState() {
	        this.currentIndex = 0;
	        this.win = jQuery(window);
	        this.tabs = this.wrapper.find('.tablinks-wrapper .tablinks');
	        this.contents = this.wrapper.find('.tabcontent-wrapper .tabcontent');
	    }
	
	    initEvents() {
	        let self = this;
	
	        for (let i = 0; i < this.tabs.length; i++) {
	            this.tabs.eq(i).on('click', function () {
	                self.tabs.removeClass('active');
	                self.contents.removeClass('active');
	                let nextIndex = parseInt($(this).attr('data-index'), 10);
	                this.currentIndex = nextIndex;
	                self.tabs.eq(nextIndex).addClass('active');
	                self.contents.eq(nextIndex).addClass('active');
	                $(window).trigger('resize');
	            });
	        }
	    }
	}
	/**
	 * UI elements
	 */
	class P_UI {
		constructor() {
			// this.initLoadMorePosts();
			this.initFocusInputs();
			this.showFilterMenu()
			this.initShowAnswers();
			this.initFormSurveyPopup();
	    this.initClosePopups();
		}
	
		initLoadMorePosts() {
			if (!$('.ajax-content').length) {
				return;
			}
	
			var currentPage = 1;
			var maxPages = parseInt($('.ajax-content').attr('data-max-pages'), 10);
	
			if (maxPages <= 1) {
				$('.load-more').addClass('is-hidden');
				return
			}
	
			$('.pagination').addClass('is-hidden');
			$('.load-more').removeClass('is-hidden');
	
			$('.load-more').on('click', function (e) {
				e.preventDefault();
				var endpoint = $('.ajax-content').attr('data-ajax-url');
				var categoryId = $('.ajax-content').attr('data-category-id');
				currentPage++;
	
				$.ajax({
					url: endpoint + '/wp-json/plodnosc/v1/blog/',
					method: 'POST',
					beforeSend: function () {
						$('.load-more').addClass('is-loading');
					},
					data: {
						page: currentPage,
						category: categoryId
					}
				}).done(function (res) {
					console.log('RES', res);
					var newHTML = $(res.html).filter('a');
					console.log('NEW HTML', newHTML);
					var maxPages = res.pagination_max_pages;
					var contentWrapper = $('.ajax-content').find('.posts-list');
	
					for (var i = 0; i < newHTML.length; i++) {
						var elementToAdd = newHTML.eq(i);
						var contentPostItem = $('<li class="post"></li>');
						elementToAdd.appendTo(contentPostItem);
						contentPostItem.appendTo(contentWrapper);
						console.log('aaaaa', i);
					}
	
					if (maxPages > currentPage) {
						$('.load-more').removeClass('is-loading');
					} else {
						$('.load-more').addClass('is-hidden');
					}
				});
			});
		}
	
		initFocusInputs() {
			var inputs = document.querySelectorAll('.has-focus');
			for (var i = 0; i < inputs.length; i++) {
				var input = inputs[i];
	
				input.addEventListener('focus', function () {
					this.parentElement.parentElement.classList.add('is-active');
				});
	
				input.addEventListener('blur', function () {
					if (this.value === '') {
						this.parentElement.parentElement.classList.remove('is-active');
					}
				});
			}
		}
	
		showFilterMenu() {
			let filterButton = $('.show-category-menu');
	
			if (filterButton.length > 0) {
				for (let i = 0; i < filterButton.length; i++) {
					let filterMenu = $('.menu-category-container');
					let filterButtonClose = $('.menu-category-title');
	
					filterButton.eq(i).on('click', function (e) {
						e.preventDefault();
						$(document.body).addClass('no-scroll');
						filterMenu.eq(i).addClass('show');
					})
	
					filterButtonClose.eq(i).on('click', function (e) {
						e.preventDefault();
						$(document.body).removeClass('no-scroll');
						filterMenu.eq(i).removeClass('show');
					})
				}
			}
		}
	
		initShowAnswers () {
			let showAnswersButton = $('.show-answers');
	
			if (showAnswersButton.length > 0) {
				let showAnswersContent = $('.ss-surveyresults');
	
				for (let i = 0; i < showAnswersButton.length; i++) {
					showAnswersButton.eq(i).on('click', function (e) {
						e.preventDefault();
						showAnswersContent.toggleClass('opened');
	
						if (showAnswersContent.hasClass('opened')) {
							showAnswersButton.html('Ukryj wyniki');
						} else {
							showAnswersButton.html('Zobacz wyniki');
							$('html, body').scrollTop($('.section-poll').offset().top)
						}
					})
				}
			}
		}
	
		initFormSurveyPopup() {
			this.formPopup = $('.survey-popup');
	
	    document.body.addEventListener('click', e => {
	      if (e.target.tagName === 'A' && e.target.getAttribute('href') === '#OpenSurveyPopup') {
	        e.preventDefault();
	        this.formPopup.removeClass('is-hidden');
	        $(document.body).addClass('no-scroll');
	      }
	    });
		}
	  
		initClosePopups() {
			let popups = $('.popup');
	
	    if (!popups.length) {
	      return
	    }
	
	    for (let i = 0; i < popups.length; i++) {
	      let closeBtn = popups.eq(i).find('.popup-close');
	      let closeOverlay = popups.eq(i).find('.popup-overlay');
	
	      closeBtn.on('click', (e) => {
	        e.preventDefault();
	        popups.eq(i).addClass('is-hidden');
	        $(document.body).removeClass('no-scroll');
	      });
	
	      closeOverlay.on('click', () => {
	        popups.eq(i).addClass('is-hidden');
					$(document.body).removeClass('no-scroll');
	      });
	    }
		}
	}
	

	new P_Menu();
	new P_FilterMenu();
	new P_UI();
	new P_SocialSharing();
	new P_SurveyPopup();

	let tabs = $('.js-tabs');
	for (let i = 0; i < tabs.length; i++) {
		new P_Tabs(tabs.eq(i));
	}

	const swiperLogotypes = new Swiper('.swiper-logotypes', {
		direction: 'horizontal',
		loop: true,
		slidesPerView: 3,
		slidesPerGroup: 3,
		speed: 3500,
		autoplay: {
			delay: 3000, // brak przerwy między przesunięciami
			disableOnInteraction: false,
		},

		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},

		pagination: {
			el: '.swiper-pagination',
			clickable: true,
		},

		freeMode: true,
		freeModeMomentum: false,

		breakpoints: {
			900: {
				slidesPerView: 5,
				slidesPerGroup: 5,
			},
			1200: {
				slidesPerView: 7,
				slidesPerGroup: 7,
			},
			1500: {
				slidesPerView: 9,
				slidesPerGroup: 9,
			}
		},
	});
})(jQuery);
